import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=a78383fa&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a78383fa')) {
      api.createRecord('a78383fa', component.options)
    } else {
      api.reload('a78383fa', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=a78383fa&", function () {
      api.rerender('a78383fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8YQZm2NC2f3Pu/JS/offershelp.vue"
export default component.exports